<template>
   <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-toolbar dark color="primary" dense>
        <v-toolbar-title class="text-body-1">
          {{ title }} {{ lendingId }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-divider></v-divider>
        <div class="row">
          <div class="col">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th style="width:90px" class="text-left">Action Id</th>
                    <th style="width:50px" class="text-left">Attempt</th>
                    
                    <th style="width: 200px">Queue Status</th>
                    <th class="text-left">Message</th>
                    <th class="text-left">StartTime</th>
                    <th class="text-left">EndTime</th>
                    <th style="width:100px" class="text-left">Is Success</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in list" :key="item.id" >
                    <td>{{ item.id }}</td>
                    <td>{{ item.AttemptNo }}</td>
                    <td>{{ getQueueStatus(item.LendingQueueStatusId) }}</td>
                    <td>{{ item.ActionStatusMessage }}</td>
                    <td>{{ item.StartTime | formatTime }}</td>
                    <td>{{ item.EndTime | formatTime}}</td>
                    <td class="text-center">
                       <v-icon v-show="item.isSuccess">mdi-check</v-icon>
                       <v-icon v-show="item.isSuccess == false">mdi-close</v-icon>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="pt-3">
        <v-spacer></v-spacer>
        <v-btn @click.native="cancel" v-if="!options.noconfirm"> Close </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import * as api from "@/api";

export default {
  name: 'LendingStatus',
  computed: {
    orderedList() {
      return this.list;
    },
  },
  created() {
    
  },
  methods: {
    open(title, lendingId) {
      this.dialog = true;
      this.title = title;
      this.lendingId = lendingId;``

      this.getLending();
    },
    cancel() {
      this.dialog = false;
    },
    getLending() {
      let that = this;
      that.overlay = true;
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getByPagin("lending/lendingStatus/" + this.lendingId, this.paging)
          .then(response => {
            that.overlay = false;
            resolve(response);
            this.paging.count = response.data.count;
            this.list = response.data.data;
            console.log(this.list);
          })
          .catch(error => {
            that.overlay = false;
            reject(error);
          });
      });
    },
    getQueueStatus(statusId) {
      let status = "";
      switch (statusId) {
        case 0:
          status = "Initializing..";
          break;
        case 1:
          status = "Queued";
          break;
        case 2:
          status = "Availability Checked";
          break;
        case 3:
          status = "License Generated";
          break;
        case 4:
          status = "Device Registered";
          break;
        case 5:
          status = "No Of Copies Updated";
          break;
        case 6:
          status = "Done";
          break;
        case 7:
          status = "Retrun License";
          break;
        case 8:
          status = "Renew License";
          break;
        case 9:
          status = "Failed";
          break;
        case 10:
          status = "Canceled";
          break;
      }

      return status;
    },
  },
  props: {
    lendingStatus: { type: Object },
  },
  computed: {

  },
  watch: {
    notify() {
      
    },
  },
  data() {
    return {
      list: [],
      lendingStatus: [],
      dialog: false,
      message: null,
      title: null,
      collectionId: {},
      lendingId : 0,
      options: {
        color: "primary",
        width: 1200,
        zIndex: 200,
        noconfirm: false,
      },
      Search: "",
      paging: { count: 10, page: 1, size: 10, keyword: "" },
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/LendingStatus.vue